import React from 'react';
import PropTypes from 'prop-types';

/**
 * TimelineQuestionCard - Family question waiting for response
 */
function TimelineQuestionCard({ question, onAnswer }) {
  const {
    id,
    asker_name,
    question: questionText,
    created_at,
  } = question;

  // Format time ago
  const formatTimeAgo = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'today';
    if (diffDays === 1) return 'yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return date.toLocaleDateString();
  };

  return (
    <div className="flex items-start gap-4 pl-4">
      {/* Timeline dot - terra cotta for questions */}
      <div
        className="
          w-4 h-4 rounded-full
          bg-fb-terra
          flex-shrink-0 mt-4
          flex items-center justify-center
        "
      >
        <span className="text-xs">✨</span>
      </div>

      {/* Connector line */}
      <div className="w-8 h-px bg-fb-terra/30 mt-6 flex-shrink-0" />

      {/* Card */}
      <div
        className="
          flex-1 bg-fb-warm rounded-lg py-4 px-4
          border border-fb-terra
        "
      >
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="font-sans text-sm font-semibold text-fb-terra mb-1">
              ✨ {asker_name || 'A family member'} asked:
            </p>
            <p className="font-sans text-sm text-gray-800 italic mb-2">
              "{questionText}"
            </p>
            <p className="font-sans text-xs text-gray-500">
              Asked {formatTimeAgo(created_at)}
            </p>
          </div>

          <button
            onClick={() => onAnswer?.(question)}
            className="
              bg-fb-terra hover:bg-fb-terra/90 text-white
              font-semibold text-sm py-2 px-4 rounded-lg
              flex items-center gap-1
              transition-colors duration-200
              flex-shrink-0 ml-4
            "
          >
            <span>🎙</span>
            <span>Answer</span>
          </button>
        </div>
      </div>
    </div>
  );
}

TimelineQuestionCard.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    asker_name: PropTypes.string,
    question: PropTypes.string.isRequired,
    created_at: PropTypes.string,
  }).isRequired,
  onAnswer: PropTypes.func,
};

TimelineQuestionCard.defaultProps = {
  onAnswer: null,
};

export default TimelineQuestionCard;
